
import React, { useState } from "react";
import { Link } from "react-router-dom";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="bg-transparent mt-5 p-4">
      <div className="flex justify-between items-center">
        <div className="text-xl font-bold">Dalu Travel And Tourism</div>
        {/* Hamburger Icon for mobile */}
        <button
          className="md:hidden text-white focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-6">
          <a href="/" className="hover:text-gray-300">
            Home
          </a>
          <Link to="/about" className="hover:text-gray-300">
            About Us
          </Link>
          {/* <Link to="/premium" className="hover:text-gray-300">
            Premium
          </Link> */}
          <a href="/blog" className="hover:text-gray-300">
            Blogs
          </a>
          <a
            href="#"
            className="hover:text-gray-300 border-2 border-white px-4 py-2 rounded-lg hover:bg-white hover:text-gray-900"
          >
            Explore
          </a>
        </div>
      </div>
      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden flex flex-col space-y-4 mt-4 bg-black bg-opacity-80 p-4 rounded-lg">
          <a href="/" className="hover:text-gray-300" onClick={() => setMenuOpen(false)}>
            Home
          </a>
          <Link to="/about" className="hover:text-gray-300" onClick={() => setMenuOpen(false)}>
            About Us
          </Link>
          <Link to="/premium" className="hover:text-gray-300" onClick={() => setMenuOpen(false)}>
            Premium
          </Link>
          <a href="/blog" className="hover:text-gray-300" onClick={() => setMenuOpen(false)}>
            Blogs
          </a>
          <a
            href="#"
            className="hover:text-gray-300 border-2 border-white px-4 py-2 rounded-lg hover:bg-white hover:text-gray-900"
            onClick={() => setMenuOpen(false)}
          >
            Explore
          </a>
        </div>
      )}
    </nav>
  );
}

export default Navbar;